<mat-dialog-content>
    <p>Only 100 records can be selected for reprocessing at one time.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onConfirm()">OK</button>
</mat-dialog-actions>
